var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.fd9fa0855185cbdfad2e2de747440ac5.svg#Q';
                    var viewUrl = 'sprites.fd9fa0855185cbdfad2e2de747440ac5.svg#view-Q';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 26 28',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };